import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.referralCode.pageTitle',
    defaultMessage: 'Referral code',
    description: 'Title of the referral code page',
  },
  pageSubtitle: {
    id: 'features.referralCode.pageSubtitle',
    defaultMessage:
      'Qualcosa è andato storto con il Referral link, inserisci di seguito il tuo Referral code',
    description: 'Subtitle of the referral code page',
  },
  pageSubtitleMobile: {
    id: 'features.referralCode.pageSubtitleMobile',
    defaultMessage: 'Qualcosa è andato storto, inserisci il tuo Referral code',
    description: 'Subtitle of the referral code page',
  },
  referralCodeButton: {
    id: 'features.referralCode.referralCodeButton',
    defaultMessage: 'INVIA CODICE',
    description: 'Label of the referral code button',
  },
  referralCodeInputLabel: {
    id: 'features.referralCode.referralCodeInputLabel',
    defaultMessage: 'Referral code',
    description: 'Label of the referral code input',
  },
  referralCodeInputPlaceholder: {
    id: 'features.referralCode.referralCodeInputPlaceholder',
    defaultMessage: 'Inserisci il referral code',
    description: 'Placeholder of the referral code input',
  },
  errorInvalidReferralCode: {
    id: 'features.referralCode.errorInvalidReferralCode',
    defaultMessage: 'Il referral code inserito non è corretto',
    description: 'Error description for invalid referral code',
  },
  errorEmptyReferralCode: {
    id: 'features.referralCode.errorEmptyReferralCode',
    defaultMessage: 'Inserire un referral code',
    description: 'Error description for empty referral code',
  },
});
